import { Link } from 'gatsby';
import { default as React } from 'react';
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  PoweredBy,
} from 'react-instantsearch-dom';

import { slugify } from '../../utils/slugify';

const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits;

  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount} result{hitCount !== 1 ? `s` : ``}
    </div>
  ) : null;
});

const PageHit = ({ hit }) => (
  <div>
    <Link to={`/episodes/${slugify(hit.id, hit.guest)}`}>
      <span className="text-gradient">
        <Highlight attribute="id" hit={hit} tagName="mark" /> -{' '}
        <Highlight attribute="guest" hit={hit} tagName="mark" />
      </span>
    </Link>
    <br />
    <small>
      <Highlight attribute="intro" hit={hit} tagName="mark" />
    </small>
  </div>
);

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <HitCount />
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
);

const SearchResult = ({ indices, className }) => (
  <div className={className}>
    {indices.map((index) => (
      <HitsInIndex index={index} key={index.name} />
    ))}
    <PoweredBy />
  </div>
);

export default SearchResult;
